import React, { Fragment, useEffect, useState } from 'react';

import { Modal } from 'react-bootstrap';
import { TimePicker, } from 'antd';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import moment from 'moment';
import Select from 'react-select';
import { CustomDatePicker, InputError } from '../../reuse/FormControls';



const ViewMsgModal = ({ newMsgModal, handleClose, isSchedule, activeItem }) => {


    const [messageType, setMessageType] = useState('');
    const [otherUserId, setOtherUserId] = useState('Not Selected');
    const [programId, setProgramId] = useState('Not Selected');
    const [scheduleDate, setScheduleDate] = useState('');
    const [scheduleTime, setScheduleTime] = useState('');
    const [templateId, setTemplateId] = useState('Not Selected');
    const [message, setMessage] = useState('');
    const [subject, setSubject] = useState('');
    const [attachments, setAttachments] = useState([]);
    // const [saveAsDefualt, setSaveAsDefualt] = useState('');


    const [messageTypeErr, setMessageTypeErr] = useState([]);
    const [reciverErr, setReciverErr] = useState('');
    const [messageErr, setMessageErr] = useState('');
    const [subjectErr, setSubjectErr] = useState('');


    useEffect(() => {
        if (isSchedule) {
            setInitials();
        }
    }, [isSchedule])



    const setInitials = () => {
        const {
            templateId, programId,
            userId,
            lastMessage,
            scheduleDateTime,
            subject,
            messageType } = activeItem
        const dT = moment(scheduleDateTime)
        setScheduleDate(dT);
        setScheduleTime(dT);
        setMessage(lastMessage);
        setSubject(subject);
        setMessageType(messageType[0])
        if(programId && programId[0].programName){
            setProgramId(programId[0].programName);

        }
        if(templateId && templateId[0].templateName){
            setTemplateId(templateId[0].templateName);

        }if(userId && userId[0].name){
             setOtherUserId(userId[0].name);
        }
        setAttachments(activeItem?.attachments ?? [])

    }


    return (
        <Modal
            size="lg"
            show={newMsgModal}
            dialogClassName="remove_header_line"
            animation={false}
            centered>

            <Modal.Header>
                <Modal.Title>Scheduled Message</Modal.Title>
                <span className="modal_close" onClick={handleClose}><i className="icon-cross" /></span>
            </Modal.Header>

            <Modal.Body>

                <div className='p-4'>


                    <div className="form-group">
                        <p className="a_label">Message Type</p>

                        <div className='d-flex justify-content-between align-items-center'>
                            <div className="check_box_wrapper cm_dark_check">
                                <input
                                    disabled
                                    onChange={() => (setMessageType(1), setMessageTypeErr(''))}
                                    type="checkbox"
                                    checked={messageType === 1} />
                                <span className="check_box"><span></span> Phone Text</span>
                            </div>
                            <div className="check_box_wrapper cm_dark_check">
                                <input
                                    disabled
                                    onChange={() => (setMessageType(2), setMessageTypeErr(''))}
                                    type="checkbox"
                                    checked={messageType === 2} />
                                <span className="check_box"><span></span> App Message</span>
                            </div>
                            <div className="check_box_wrapper cm_dark_check">
                                <input
                                    disabled
                                    onChange={() => (setMessageType(3), setMessageTypeErr(''))}
                                    type="checkbox"
                                    checked={messageType === 3} />
                                <span className="check_box"><span></span> Email</span>
                            </div>

                            {/* <div className="check_box_wrapper cm_dark_check">
                                <input
                                    disabled
                                    // disabled={!messageType}
                                    onChange={() => setSaveAsDefualt(saveAsDefualt ? 0 : 1)}
                                    type="radio"
                                    checked={saveAsDefualt} />
                                <span className="check_box"><span></span> Save above as default</span>
                            </div> */}
                        </div>

                        {messageTypeErr ? <h6 className='cm_err'>{messageTypeErr}</h6> : ''}
                    </div>



                    <div className='row'>
                        <div className='col'>
                            <div className="form-group">
                                <label>To User</label>
                                <input
                                    disabled
                                    placeholder="Select User"
                                    value={otherUserId}
                                    classNamePrefix="cm_select"
                                    onChange={e => (setOtherUserId(e))}
                                    className={`form-control ${false ? 'is-invalid' : ''}`}
                                //options={users.map(i => ({label: <div className='drop_with_img'><img src={i.profileImage || UserImg} /> <span>{i.name} <small>{i.email}</small></span></div>, value: i._id}))} />
                                // options={users.map(i => ({ label: `${i.name} ${i.email}`, value: i._id }))}
                                />
                            </div>
                        </div>
                        <div className='col'>
                            <div className="form-group">
                                <label>To Program</label>
                                <input
                                    disabled
                                    placeholder="Programs"
                                    value={programId}
                                    classNamePrefix="cm_select"
                                    onChange={e => (setProgramId(e), setOtherUserId(''), setReciverErr(''))}
                                    className={`form-control ${false ? 'is-invalid' : ''}`}
                                    // options={programsList.map(i => ({ label: i.programName, value: i._id }))}
                                />
                            </div>
                        </div>
                    </div>

                    {reciverErr ? <h5 className='cm_err text-center position-relative' style={{ bottom: '20px' }}>{reciverErr}</h5> : ''}





                    <div className="form-group">
                        <p className="a_label">Schedule Send for Later</p>

                        <div className='row'>
                            <div className='col'>
                                <div className="form-group">
                                    <label>Date</label>
                                    <CustomDatePicker
                                        disabled
                                        value={scheduleDate}
                                        error={''}
                                        disabledDate={current => current && current < moment.utc(new Date().getTime() - 86400000)}
                                    // change={handleScheduleDate} 
                                    />
                                </div>
                            </div>
                            <div className='col'>
                                <div className="form-group">
                                    <label>Time</label>
                                    <TimePicker
                                        disabled
                                        use12Hours
                                        value={scheduleTime}
                                        format="h:mm a"
                                        // onChange={handleScheduleTime}
                                        className={`form-control`} />
                                </div>

                            </div>
                        </div>
                    </div>


                    {
                        messageType === 3 ? <div className="form-group">
                            <label>Subject</label>
                            <input
                                disabled
                                type='text'
                                value={subject}
                                onChange={e => (setSubject(e.target.value), setSubjectErr(''))}
                                className={`form-control ${subjectErr ? 'is-invalid' : ''}`} />
                            <InputError error={subjectErr} />
                        </div> : ''
                    }









                    <div className="form-group">
                        <div className='d-flex justify-content-sm-between align-items-center mb-3'>
                            <p className='a_label mb-0'>Message</p>
                            <div className='w-50'>
                                <input
                                    disabled
                                    placeholder="Select Template"
                                    value={templateId}
                                    classNamePrefix="cm_select"
                                    onChange={e => (setTemplateId(e))}
                                    className={`form-control`}
                                    // options={templateList.map(i => ({ ...i, label: i.name, value: i._id }))} 
                                    />
                            </div>
                        </div>
                        <div className={messageErr ? 'error_feild' : ''}>
                            <ReactQuill
                                isDisabled
                                className={`inbox_editer ${0 ? 'is-invalid' : ''}`}
                                theme="snow"
                                value={message}
                                onChange={e => (setMessage(e), setTemplateId(''), setMessageErr(''))} />

                            {messageErr ? <h6 className='cm_err'>{messageErr}</h6> : ''}
                        </div>
                        {
                            attachments.length > 0 &&
                            <div className="mt-2">
                                <p>Attachments :</p>
                                {
                                    attachments.map((a, i) =>
                                        <p>
                                            {i + 1}.
                                            <a href={a.url} target="_blank" rel="noreferrer">
                                                <i style={{ fontSize: 25 }} className="icon-folder mx-1"></i>
                                            </a>
                                        </p>
                                    )
                                }
                            </div>
                        }
                    </div>

                </div>

            </Modal.Body>
        </Modal>
    )
}



export default ViewMsgModal;